<script setup lang="ts">
import PasswordReset from "@/components/auth/PasswordReset.vue";
import { useAuthStore } from "@/stores";
import AccountActivation from "../../components/auth/AccountActivation.vue";

enum ActionMode {
	RESET_PASSWORD,
	ACCOUNT_ACTIVATION,
}

const route = useRoute();

const mode = computed(() => {
	const queryMode = (route.query.mode as string) || "";
	if (queryMode === "resetPassword") return ActionMode.RESET_PASSWORD;
	if (queryMode === "verifyEmail") return ActionMode.ACCOUNT_ACTIVATION;

	return null;
});

const oobCode = computed(() => (route.query.oobCode as string) || "");

const validCode = ref(false);
const initialised = ref(false);

const authStore = useAuthStore();

authStore.isValidActionCode(oobCode.value).then((valid) => {
	validCode.value = valid;
	initialised.value = true;
});
</script>

<template>
	<div v-if="initialised" class="flex flex-col gap-2 size-full">
		<template v-if="!validCode || mode == null">
			<h2>{{ $t("auth.verifyEmail") }}</h2>
			<span>{{ $t("auth.linkExpired") }}</span>
		</template>
		<template v-else>
			<PasswordReset v-if="mode === 0" :code="oobCode" />
			<AccountActivation v-if="mode === 1" :code="oobCode" />
		</template>
	</div>
</template>
